import { Route, Routes as RoutesContainer } from "react-router";
import { Dashboard } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/dashboard' element={<Dashboard />} />
    </RoutesContainer>
  );
};
export default Routes;
